import type { DatabaseAIChangeRow } from '../../releasegovernance/framework';

type Props = { items?: DatabaseAIChangeRow[] };

export function DatabaseAIChangePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.changeType}-${item.item}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs text-slate-400">{item.changeType}</p>
              <p className="text-sm font-medium">{item.item}</p>
            </div>
            <div className="text-right">
              <span className="rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
                {item.status}
              </span>
              <p className="mt-1 text-xs text-slate-500">Risk: {item.risk}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
